export const RecoveryLoc = {
    recoverySuccess: {
        title: {
            ru: 'Пароль успешно восстановлен',
            en: 'You have successfully recovered your password',
        },
        text: {
            ru: 'Теперь вы можете войти в личный кабинет.',
            en: 'Now you can login to you account.',
        },
    },
};
